import { TransformedFileDetails, TransformedFileEntry } from '../types/FileApiResponseTransformed';
import { FileDetails } from '../types/ApiFileDetails';

export function transformFileApiResponse(response: FileDetails): TransformedFileDetails {
  // Normalize entry to always be an array
  response.entry = response.entry || [];
  const entries = Array.isArray(response.entry) ? response.entry : [response.entry];

  const details: TransformedFileDetails = {
    meta: {
      aboutFile: response.meta.aboutfile,
      canDownload: Boolean(Number(response.meta.candownload)),
      canSetAcls: Boolean(Number(response.meta.cansetacls)),
      canUpload: Boolean(Number(response.meta.canupload)),
      defaultFile: response.meta.defaultfile,
      isRoot: Boolean(Number(response.meta.isroot)),
      isShareable: Boolean(Number(response.meta.isshareable)),
      message: response.meta.message,
      parentPath: response.meta.parentpath,
      realPath: response.meta.realpath,
      result: Boolean(Number(response.meta.result)),
      showShareOption: Boolean(Number(response.meta.showshareoption)),
      showZipFolders: Boolean(Number(response.meta.showzipfolders)),
      teamFolder: Boolean(Number(response.meta.teamfolder)),
      total: Number(response.meta.total),
    },
    entry:
      entries?.map(item => ({
        path: item.path,
        dirPath: item.dirpath,
        name: item.name,
        ext: item.ext,
        fullSize: item.fullsize,
        modified: item.modified,
        type: item.type,
        fullFileName: item.fullfilename,
        size: item.size,
        modifiedEpoch: item.modifiedepoch,
        modifiedEpochUTC: item.modifiedepochutc,
        modifiedISO: item.modifiediso,
        favoriteListId: item.favoritelistid,
        favoriteId: item.favoriteid,
        order: item.order,
        lastModifiedBy: item.lastmodifiedby,
        // Changing to boolean from string
        canDownload: Boolean(Number(item.candownload)),
        canFavorite: Boolean(Number(item.canfavorite)),
        canManageShare: Boolean(Number(item.canmanageshare)),
        canRename: Boolean(Number(item.canrename)),
        canSetAcls: Boolean(Number(item.cansetacls)),
        canUpload: Boolean(Number(item.canupload)),
        commented: Boolean(Number(item.commented)),
        drmWebViewer: Boolean(Number(item.drmwebviewer)),
        hasNotificationsRule: Boolean(Number(item.hasnotificationsrule)),
        isDataSyncable: Boolean(Number(item.isdatasyncable)),
        isReshared: Boolean(Number(item.isreshared)),
        isRoot: Boolean(Number(item.isroot)),
        isShareable: Boolean(Number(item.isshareable)),
        isSyncable: Boolean(Number(item.issyncable)),
        isShared: Boolean(Number(item.isshared)),
        showLockUnlock: Boolean(Number(item.showlockunlock)),
        showPrev: Boolean(Number(item.showprev)),
        showQuickEdit: Boolean(Number(item.showquickedit)),
        showShareOption: Boolean(Number(item.showshareoption)),
        tagged: Boolean(Number(item.tagged)),
      })) || [],
  };

  // Add "back" directory if parentPath is not empty
  if (response.meta.parentpath?.trim() !== '') {
    details.entry.unshift({
      name: '...',
      path: response.meta.parentpath,
      isRoot: true,
      ext: '',
      type: 'dir',
      back: true,
    } as TransformedFileEntry);
  }

  return details;
}
